
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/[handle]",
      function () {
        return require("private-next-pages/program/[handle]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/[handle]"])
      });
    }
  